import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

type Edits = Readonly<Record<string, unknown>>

@Injectable({ providedIn: 'any' })
export class TableEditableDataService {
  public readonly data$ = new BehaviorSubject<Edits>({})

  update(key: string, value: unknown) {
    const data: Record<string, unknown> = { ...this.data$.getValue() }
    if (value === '' || value == null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete data[key]
    } else {
      data[key] = value
    }
    this.data$.next(data)
  }

  getData() {
    return this.data$.getValue()
  }
}